import { PDI_ROUTES, TENANTS } from "../constants"
import { en_BE } from "./en-BE"
import { en_FR } from "./en-FR"
import { en_NL } from "./en-NL"
import { es_ES } from "./es-ES"
import { fr_BE } from "./fr-BE"
import { fr_FR } from "./fr-FR"
import { it_IT } from "./it-IT"
import { nl_BE } from "./nl-BE"
import { nl_NL } from "./nl-NL"
import { pt_PT } from "./pt-PT"
import {
  VOYAGEUR_LANG_KEY,
  VOYAGEUR_SUPPORTED_LANGS,
  getSessionVoyageurLang,
  normalizeVoyageurLangCode
} from "./voyageurLanguage"
import axios from "axios"
import EventEmitter from "eventemitter3"
import moment from "moment"
import { Cookies } from "react-cookie"

export function isEmpty(s) {
  return !s
}

export var debug = false
export function setDebug(d) {
  debug = d
}

// **********************************
// Localization
// **********************************
const DEFAULT_EN_LOCALIZED_STRINGS = { isEnglish: true, AplazameConfirmation: "Confirmation" }
var _localizedStrings = { ...DEFAULT_EN_LOCALIZED_STRINGS }

function getBundleForVoyageurLang(code) {
  switch (code) {
    case "fr-FR":
      return { ...fr_FR, isEnglish: false }
    case "fr-BE":
      return { ...fr_BE, isEnglish: false }
    case "en-FR":
      return { ...en_FR, isEnglish: false }
    case "en-BE":
      return { ...en_BE, isEnglish: false }
    case "en-NL":
      return { ...en_NL, isEnglish: false }
    case "it-IT":
      return { ...it_IT, isEnglish: false }
    case "pt-PT":
      return { ...pt_PT, isEnglish: false }
    case "es-ES":
      return { ...es_ES, isEnglish: false }
    case "nl-BE":
      return { ...nl_BE, isEnglish: false }
    case "nl-NL":
      return { ...nl_NL, isEnglish: false }
    default:
      return { isEnglish: true }
  }
}

/** Langue persistée (parcours voyageur) : `voyageur_lang`, repli lecture `pdi_lang`. */
export function setVoyageurLanguage(shortCode, supportedLanguages) {
  const code = normalizeVoyageurLangCode(shortCode)
  if (!code) return
  const allowed =
    Array.isArray(supportedLanguages) && supportedLanguages.length > 0
      ? supportedLanguages
          .map((c) => normalizeVoyageurLangCode(c))
          .filter((c) => VOYAGEUR_SUPPORTED_LANGS.includes(c))
      : VOYAGEUR_SUPPORTED_LANGS
  if (!allowed.includes(code)) return
  try {
    sessionStorage.setItem(VOYAGEUR_LANG_KEY, code)
  } catch (e) {
    /* ignore quota / private mode */
  }
  // Invalider le cache i18n : la prochaine `loc()` rechargera le bundle depuis `getSessionVoyageurLang()`.
  _localizedStrings = { isEnglish: true }
  window.dispatchEvent(new CustomEvent("voyageurLanguageChange", { detail: code }))
}

export function getVoyageurLangDisplayCode() {
  return (getSessionVoyageurLang() || "fr-FR").toUpperCase()
}

function loc(strings, ...values) {
  if (!strings) return strings
  // TODO CLEMENT régler la langue par défaut sur tunnelData.data.order.language
  const sessionLangActive = getSessionVoyageurLang()
  if (
    _localizedStrings.isLoaded &&
    sessionLangActive &&
    _localizedStrings.__voyageurLang != null &&
    _localizedStrings.__voyageurLang !== sessionLangActive
  ) {
    _localizedStrings = { isEnglish: true }
  }
  if (!_localizedStrings.isLoaded) {
    let config = userConfigurationService.getUserConfiguration()
    const sessionLang = getSessionVoyageurLang()
    if (sessionLang) {
      _localizedStrings = { ...getBundleForVoyageurLang(sessionLang) }
      if (config && config.overrides) {
        _localizedStrings = { ..._localizedStrings, ...config.overrides }
      }
      _localizedStrings.__voyageurLang = sessionLang
      _localizedStrings.isLoaded = true
    } else if (config) {
      if (config.user.locale === "fr-FR") {
        _localizedStrings = fr_FR
        _localizedStrings.isEnglish = false
      } else if (config.user.locale === "nl-BE") {
        _localizedStrings = nl_BE
        _localizedStrings.isEnglish = false
      } else if (config.user.locale === "nl-NL") {
        _localizedStrings = nl_NL
        _localizedStrings.isEnglish = false
      } else if (config.user.locale === "fr-BE") {
        _localizedStrings = fr_BE
        _localizedStrings.isEnglish = false
      } else if (config.user.locale === "it-IT") {
        _localizedStrings = it_IT
        _localizedStrings.isEnglish = false
      } else if (config.user.locale === "es-ES") {
        _localizedStrings = es_ES
        _localizedStrings.isEnglish = false
      } else if (config.user.locale === "pt-PT") {
        _localizedStrings = pt_PT
        _localizedStrings.isEnglish = false
      } else if (!config.user.locale || config.user.locale === "en-GB" || config.user.locale === "en-US") {
        // do nothing
      } else {
        notificationService.addNotification(
          `Unsupported locale "${config.user.locale}" for user "${config.user.username}"`,
          "error"
        )
      }
      if (config.overrides) _localizedStrings = { ..._localizedStrings, ...config.overrides }
      _localizedStrings.isLoaded = true
    }
  }

  if (typeof strings === "string") strings = [strings]
  let key = strings.join("$")
  let lstrings = _localizedStrings[key]

  let missing
  if (!lstrings) {
    lstrings = strings
    if (strings.length === 1) lstrings = lstrings[0]
    _localizedStrings[key] = lstrings
    missing = true
  }
  if (missing && debug && !_localizedStrings.isEnglish) {
    console.log("Missing localized:<<" + key + ">>", _localizedStrings.isEnglish)
  }

  strings = lstrings
  let lstr
  if (lstrings.elementHtml) {
    const localProps = values?.[0]
    if (typeof lstrings.elementHtml === "function") {
      return lstrings.elementHtml(localProps)
    }
    return lstrings.elementHtml
  } else if (strings.propsValues) {
    const localProps = values?.[0]
    return lstrings.propsValues(localProps)
  } else if (typeof strings === "string") {
    lstr = strings
  } else {
    let array = []
    for (let i = 0; i < values.length; i++) {
      array.push(strings[i], values[i])
    }
    array.push(strings[values.length])
    lstr = array.join("")
  }
  return lstr
}

// **********************************
// Axios
// **********************************
export function formatAxiosError(error) {
  error &&
    console.log(
      "===",
      error,
      error.response,
      error.response && error.response.data,
      error.response && error.response.data && error.response.data.message
    )
  let msg
  if (error.response && error.response.data) {
    msg = debug ? error.response.data.stack : error.response.data.message || error.response.data
    let data = error.response.data
    if (debug && data.stack) {
      msg = data.stack
    } else {
      let array = data.strings
      if (array) msg = loc(data.message, ...array)
      else msg = error.response.data.message || error.response.data || error.message
    }
    msg += " (" + error.response.status + ")"
  }
  if (!msg) msg = debug && error.stack ? error.stack : error.message
  return msg
}

var _headersAuthorizations
export function getHeadersAuthorizations() {
  return _headersAuthorizations || window.localStorage.getItem("headersAuthorizations")
}

export function getAuthorizationsToken() {
  return getHeadersAuthorizations().substring("bearer ".length)
}

export function setupAxiosClient(baseUrl) {
  //axios.defaults.headers.common["X-CORRELATION-ID"] = uuidv4()

  // eslint-disable-next-line no-unused-vars
  function sameOrigin(url) {
    return url.startsWith("/api") || url.startsWith(baseUrl)
  }

  _headersAuthorizations = getHeadersAuthorizations()
}

//***********************************
// Locale & formats
//***********************************
/*
 * Returns 1 if the IBAN is valid
 * Returns FALSE if the IBAN's length is not as should be (for CY the IBAN Should be 28 chars long starting with CY )
 * Returns any other number (checksum) when the IBAN is invalid (check digits do not match)
 */
function isValidIban(input) {
  var CODE_LENGTHS = {
    AD: 24,
    AE: 23,
    AT: 20,
    AZ: 28,
    BA: 20,
    BE: 16,
    BG: 22,
    BH: 22,
    BR: 29,
    CH: 21,
    CR: 21,
    CY: 28,
    CZ: 24,
    DE: 22,
    DK: 18,
    DO: 28,
    EE: 20,
    ES: 24,
    FI: 18,
    FO: 18,
    FR: 27,
    GB: 22,
    GI: 23,
    GL: 18,
    GR: 27,
    GT: 28,
    HR: 21,
    HU: 28,
    IE: 22,
    IL: 23,
    IS: 26,
    IT: 27,
    JO: 30,
    KW: 30,
    KZ: 20,
    LB: 28,
    LI: 21,
    LT: 20,
    LU: 20,
    LV: 21,
    MC: 27,
    MD: 24,
    ME: 22,
    MK: 19,
    MR: 27,
    MT: 31,
    MU: 30,
    NL: 18,
    NO: 15,
    PK: 24,
    PL: 28,
    PS: 29,
    PT: 25,
    QA: 29,
    RO: 24,
    RS: 22,
    SA: 24,
    SE: 24,
    SI: 19,
    SK: 24,
    SM: 27,
    TN: 24,
    TR: 26
  }
  var iban = String(input)
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, ""), // keep only alphanumeric characters
    code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
    digits

  if (code === null) {
    return false
  }
  if (!CODE_LENGTHS.hasOwnProperty(code[1])) {
    return true
  }
  // check syntax and length
  if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
    return false
  }
  // rearrange country code and check digits, and convert chars to ints
  digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
    return letter.charCodeAt(0) - 55
  })
  // final check
  return mod97(digits) === 1
}
function mod97(string) {
  var checksum = string.slice(0, 2),
    fragment
  for (var offset = 2; offset < string.length; offset += 7) {
    fragment = String(checksum) + string.substring(offset, offset + 7)
    checksum = parseInt(fragment, 10) % 97
  }
  return checksum
}

// **********************************
// ListsService
// **********************************
class ListsService {
  constructor() {
    this.listCache = {}
  }

  register(list) {
    list.values = list.values.map((item) =>
      item.label ? { ...item, label: loc(item.label) } : { ...item, label: item.value }
    )
    list.labels = {}
    list.items = {}
    for (let i = 0; i < list.values.length; i++) {
      let item = list.values[i]
      list.labels[item.value] = item.label || item.value
      list.items[item.value] = item
    }
    this.listCache[list.name] = list
  }

  reset() {
    this.listCache = {}
  }

  deregister(name) {
    delete this.listCache[name]
  }

  deregisterAll() {
    this.listCache = {}
  }

  getList(name, handleLoaded) {
    if (this.listCache[name]) {
      let list = this.listCache[name]
      if (handleLoaded && list.handleLoadedCallbacks) {
        // list is loading, add callback
        if (list.handleLoadedCallbacks.length < 100) {
          // 100 max in case there is an infinite loop caused by some bug
          list.handleLoadedCallbacks.push(handleLoaded)
        }
      }
      return list
    } else {
      this.register({
        name,
        values: [],
        handleLoadedCallbacks: (handleLoaded && [handleLoaded]) || []
      })
      let url = name.startsWith("/") ? name : "/api/script/lists?lists=" + name
      axios
        .get(url)
        .then((response) => {
          let data = response.data
          let loadingLists = []
          // DO NOT CHANGE ANYTHING UNLESS YOU KNOW WHAT YOU ARE DOING !!
          // here this is tricky because in case of list we can have lots of hooks to call
          // first replace all loading list (with callbacks) with there loaded version (without callbacks)
          for (let dataItem of data) {
            dataItem.name = name
            let loadingList = this.listCache[dataItem.name]
            if (loadingList && loadingList.handleLoadedCallbacks) loadingLists.push(loadingList)
            this.register(dataItem)
          }
          // then execute callbacks
          for (let loadingList of loadingLists) {
            let loadedList = this.listCache[loadingList.name]
            loadingList.handleLoadedCallbacks.forEach((handleLoaded) => handleLoaded(loadedList))
          }
        })
        .catch((error) => {
          console.log(error)
          notificationService.addNotification(loc`List not found '${name}': ${error.message}`, "error")
        })
      return this.listCache[name]
    }
  }

  getValues(name, handleLoaded) {
    let list = this.getList(name, handleLoaded)
    if (list) return list.values
    return undefined
  }

  getLabel(listName, value, handleLoaded) {
    if (!value) return value
    let list = this.getList(listName, handleLoaded)
    return list ? list.labels[value] || value : value
  }

  getItem(listName, value, handleLoaded) {
    if (!value) return value
    let list = this.getList(listName, handleLoaded)
    return list ? list.items[value] || value : value
  }
}

// **********************************
// SpnnerService
// **********************************
class SpinnerService {
  constructor() {
    this.spinnerComponent = null
  }
  register(sc) {
    this.spinnerComponent = sc
  }
  show() {
    if (this.spinnerComponent) this.spinnerComponent.show()
  }
  hide() {
    if (this.spinnerComponent) this.spinnerComponent.hide()
  }
}

// **********************************
// NotificationService
// **********************************
class NotificationService {
  constructor() {
    this.notificationComponent = null
    //this.getValues = this.getValues.bind(this);
    //this.register  = this.register.bind(this);
  }
  register(nc) {
    this.notificationComponent = nc
  }
  unregister(nc) {
    this.notificationComponent = null
  }
  addNotification(message, level = "success", position = "br", action) {
    //if (!action && level === "info") action = { label: "Install it!", callback: () => {}};
    this.notificationComponent &&
      this.notificationComponent.handleNotification(message, level, position, action ? 30 : 5, action)
  }
  addOups(what, errorException) {
    what = loc(what)
    let message = loc`Oups, something went wrong`
    if (what) message += " " + what
    if (errorException) message += ": " + formatAxiosError(errorException)
    this.addNotification(message, "error")
    console.log(errorException)
  }
  getHistory() {
    return this.notificationComponent && this.notificationComponent.props.history
  }
}

export function arrayIntersects(array1, array2) {
  if (array1 && array2) {
    if (!Array.isArray(array1)) array1 = [array1]
    if (!Array.isArray(array2)) array2 = [array2]
    for (let it1 of array1) {
      for (let it2 of array2) {
        if (it1 === it2) return true
      }
    }
  }
  return false
}

// **********************************
// UserConfiguration
// **********************************
class UserConfigurationService {
  constructor() {
    this.userConfiguration = null
  }

  // register(component) {
  // this.component = component;
  // }

  // async loadUserConfiguration(force = false) {
  // if (!force && this.userConfiguration) {
  // return this.userConfiguration;
  // } else {
  // try {
  // this.userConfiguration = (await axios.get("/api/script/runs/user-configuration")).data;
  // let userProfiles = this.userConfiguration.user.profiles;
  // this.menus = this.userConfiguration.menus.filter(
  // it => !it.profiles || arrayIntersects(it.profiles, userProfiles)
  // );
  // } catch (error) {
  // notificationService.addOups(loc`loading user configuration`, error);
  // }
  // try {
  // this.userConfiguration.overrides = (await axios.get("/api/script/runs/string-overrides")).data;
  // } catch (error) {
  // notificationService.addOups(loc`loading string overrides`, error);
  // }
  // this.component.setState({ isUserConfigurationLoaded: true });
  // return this.userConfiguration;
  // }
  // }

  register(configuration) {
    this.userConfiguration = configuration
  }

  unloadUserConfiguration() {
    this.userConfiguration = null
  }

  getUserConfiguration() {
    return this.userConfiguration
  }

  getMenus() {
    return this.menus
  }

  getUserId() {
    let config = this.userConfiguration
    if (config && config.user) return config.user._id
  }

  getUsername() {
    let config = this.userConfiguration
    if (config && config.user) return config.user.username
  }

  getLocale() {
    let config = this.userConfiguration
    if (config && config.user) return config.user.locale
  }

  getTenant() {
    let config = this.userConfiguration
    if (config && config.user) return config.user.tenant
  }

  getProfiles() {
    let config = this.userConfiguration
    if (config && config.user) return config.user.profiles
  }

  hasProfile(profile) {
    let config = this.userConfiguration
    return config && config.user && arrayIntersects(config.user.profiles, profile)
  }

  getIsAdmin() {
    let config = this.userConfiguration
    if (config && config.user) return config.user.isAdmin
  }

  getIsMainAdmin() {
    let config = this.userConfiguration
    if (config && config.user) return config.user.isMainAdmin
  }

  getIsSuperAdmin() {
    let config = this.userConfiguration
    if (config && config.user) return config.user.isSuperAdmin
  }

  getScriptOverride(scriptName) {
    let config = this.userConfiguration
    if (config && config && config.scriptOverrides) return config.scriptOverrides[scriptName]
  }
}

// **********************************
// AuthenticationService
// **********************************
class AuthenticationService extends EventEmitter {
  constructor() {
    super()
    this.authenticated = true
  }

  /**
  async authenticationCheck() {
    try {
      return (await axios.get("/api/authentication-check")) && true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
   */

  isAuthenticated() {
    return this.authenticated
  }

  userHasLoggedOut() {
    this.authenticated = false
    this.emit({ authenticated: false })
  }

  userHasLoggedIn() {
    this.authenticated = true
    this.emit({ authenticated: true })
  }
}

function resetServices() {
  listsService.reset()
  userConfigurationService.userConfiguration = null
  userConfigurationService.loadUserConfiguration(true)
  //notificationService.unregister();
  _localizedStrings = { ...DEFAULT_EN_LOCALIZED_STRINGS }
}

export function downloadFileFromUrl(url, okMessage, koMessage) {
  axios
    .get(url, { responseType: "blob" })
    .then((response) => {
      // Try to find out the filename from the content disposition `filename` value
      const disposition = response.headers["content-disposition"]
      if (!disposition) {
        return
      }
      const matches = /"([^"]*)"/.exec(disposition) // TODO: tell Thomas, does not extract filename (in my case; "attachment; filename=theDocument.xml")

      let filename = "file.docx"
      if (matches != null && matches[1]) {
        filename = matches[1]
      } else {
        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition)
        if (matches != null && matches[1]) {
          filename = matches[1]
        }
      }

      // The actual download
      var blob = new Blob([response.data])
      var link = document.createElement("a")
      link.href = window.URL.createObjectURL(blob)
      link.download = filename

      document.body.appendChild(link)

      link.click()

      // const url = window.URL.createObjectURL(new Blob([response.data]));
      // const link = report.createElement('a');
      // link.href = url;
      // link.setAttribute('download', 'file.docx');
      // report.body.appendChild(link);
      // link.click();

      document.body.removeChild(link)

      notificationService.addNotification(loc(okMessage))
    })
    .catch(async (error) => {
      // in case of error we get a blob so we need to fix it to display a proper error
      try {
        if (error.response && error.response.data && error.response.data instanceof Blob) {
          let response = await new Response(error.response.data).text()
          let json = JSON.parse(response)
          error.response.data = json
        }
      } catch {}
      notificationService.addOups(loc(koMessage), error)
      throw error
    })
}

export function searchParamToObject(query) {
  let object = {}
  const searchParam = new URLSearchParams(query)
  for (let [field, value] of searchParam) object[field] = value
  return object
}

export function objectToSearchParam(prefix, object) {
  // this works but the URL is ugly with commas and it is unnecessary since modern browser are permissive
  // const searchParam = new URLSearchParams();
  // for (let field in object) {
  // if (object[field]) searchParam.append(field, object[field]);
  // }
  // let str = searchParam.toString();
  // return str ? "?" + str : str;

  // we use this version instead
  let str = Object.keys(object)
    .map((field) => object[field] && field + "=" + object[field])
    .filter((it) => it)
    .join("&")
  return prefix && str ? prefix + str : str
}

export function isStrangerTenant(tenant) {
  const tenantsToTest = [
    TENANTS.SAMSUNG_IT,
    TENANTS.SAMSUNG_ES,
    TENANTS.SAMSUNG_ES_APZ,
    TENANTS.SAMSUNG_PT,
    TENANTS.SAMSUNG_NL,
    TENANTS.SAMSUNG_BE,
    TENANTS.RETAIL_IT,
    TENANTS.RETAIL_FNAC_PT,
    TENANTS.SENSO_IT,
    TENANTS.MEDIAMARKT_NL,
    TENANTS.MEDIAMARKT_BE
  ]
  return tenantsToTest.includes(tenant)
}

export function isItalianTenant(tenant) {
  const italianTenants = [TENANTS.SAMSUNG_IT, TENANTS.RETAIL_IT, TENANTS.SENSO_IT]
  return italianTenants.includes(tenant)
}

export function isPdiRetailTenant(tenant) {
  const tenantsToTest = [
    TENANTS.MORTAR,
    TENANTS.BUT,
    TENANTS.RETAIL_IT,
    TENANTS.RETAIL_FNAC_PT,
    TENANTS.MEDIAMARKT_NL,
    TENANTS.MEDIAMARKT_BE,
    TENANTS.CONFORAMA_RETAIL
  ]
  return tenantsToTest.includes(tenant)
}

export function isPortugueseTenant(tenant) {
  const portugueseTenant = [TENANTS.RETAIL_FNAC_PT]
  return portugueseTenant.includes(tenant)
}

export function isDutchTenant(tenant) {
  const dutchTenants = [TENANTS.SAMSUNG_NL, TENANTS.MEDIAMARKT_NL, TENANTS.MEDIAMARKT_BE]
  return dutchTenants.includes(tenant)
}

export function isPdiRetailRoutes(pathname) {
  const pdiRetailRoutes = [PDI_ROUTES.HOME, PDI_ROUTES.SIMULATION, PDI_ROUTES.RESUME_ORDER]

  // handle browser back button for dynamic simulation route with opl if coming back from identification page after Simulation CreateOrder.
  const isSimulationWithOplRoute = pathname.includes("/simulation/")
  // example of isSimulationWithOplRoute -> "/simulation/230718047W9Q9"
  // when ? first : createOrder from SimulationPage then click on the "go back to shop" button on IdentificationPage
  if (isSimulationWithOplRoute) {
    pdiRetailRoutes.push(pathname)
  }

  return pdiRetailRoutes.includes(pathname)
}

export function getFieldsFiltered(registeredFields, targetFields) {
  return registeredFields.filter((fieldClientPage) => fieldClientPage.includes(targetFields))
}

export function countCompletedFields(filteredBlocFields, hasErrors, errors, ignoredFields = []) {
  const countedFields = filteredBlocFields.filter(
    (fieldClientPage) => !ignoredFields.some((ignoredField) => fieldClientPage.endsWith(ignoredField))
  )
  const countedErrors = errors
    ? Object.getOwnPropertyNames(errors).filter((errorField) => !ignoredFields.includes(errorField))
    : []
  if (hasErrors && errors) {
    return countedFields.length - countedErrors.length
  } else {
    return countedFields.length
  }
}

export const PDI_RETAIL_ORIGIN_QUERY_PARAM = "pdiRetailOrigin"
export const PDI_RETAIL_ORIGIN_COOKIE = "PDI_RETAIL_ORIGIN"

export function normalizePdiRetailBaseUrl(url) {
  if (!url || typeof url !== "string") return ""
  const trimmed = url.trim()
  if (!trimmed) return ""
  return trimmed.endsWith("/") ? trimmed : `${trimmed}/`
}

/**
 * URL de retour vers le portail PDI : query param > cookie .evollis.com > config voyager-script.
 */
export function resolvePdiRetailBaseUrl(tunnelData, query) {
  const fromQuery = query?.get(PDI_RETAIL_ORIGIN_QUERY_PARAM)
  if (fromQuery) {
    try {
      return normalizePdiRetailBaseUrl(decodeURIComponent(fromQuery))
    } catch {
      return normalizePdiRetailBaseUrl(fromQuery)
    }
  }

  const cookies = new Cookies()
  const fromCookie = cookies.get(PDI_RETAIL_ORIGIN_COOKIE)
  if (fromCookie) {
    try {
      return normalizePdiRetailBaseUrl(decodeURIComponent(fromCookie))
    } catch {
      return normalizePdiRetailBaseUrl(fromCookie)
    }
  }

  return normalizePdiRetailBaseUrl(tunnelData?.pdiRetailUrl ?? "")
}

export function getCookiesAccessToken() {
  const cookies = new Cookies()

  let cookieToken = undefined
  if (cookies.get("TOKEN")) {
    cookieToken = cookies.get("TOKEN")
  } else {
    cookieToken = cookies.get("TOKEN_PART_ONE") + cookies.get("TOKEN_PART_TWO")
  }
  const cookieHeader = cookies.get("TOKEN_HEADER")
  const cookieOptions = cookies.get("TOKEN_OPTIONS")

  return { cookieToken, cookieHeader, cookieOptions }
}

export function extractLinkTags(string) {
  const regex = /<a\s+[^>][^>](.*?)<\/a>/gi
  const linkTags = string.match(regex) ?? []
  return linkTags
}

const authenticationService = new AuthenticationService()
const notificationService = new NotificationService()
const spinnerService = new SpinnerService()
const listsService = new ListsService()
const userConfigurationService = new UserConfigurationService()
export {
  loc,
  isValidIban,
  authenticationService,
  notificationService,
  listsService,
  spinnerService,
  userConfigurationService,
  resetServices
}

/**
 * Takes the date object that is exposed from back end APIs and converts it to moment Object
 * @param {*} input : array of numbers : [2023, 6, 7, 10, 21, 41, 581000000] year, month, day, hour, ...
 * @returns moment() type object
 */
export function mapBackEndDateToMomentObject(input) {
  if (!input) return null
  const date = moment()
  date.set("year", input[0])
  date.set("month", input[1] - 1)
  date.set("date", input[2])
  date.set("hour", input[3])
  date.set("minute", input[4])
  date.set("second", input[5])
  return date
}

/**
 * Permet de formater un numéro de téléphone français, en 0x xx xx xx xx ou en + 33 x xx xx xx xx
 * @param phoneNumber
 * @returns string
 */
export function formatFrenchPhoneNumber(phoneNumber) {
  let cleaned = phoneNumber.replace(/\D/g, "")
  if (cleaned.startsWith("33")) {
    return cleaned.replace(/^33(\d)(\d{2})(\d{2})(\d{2})(\d{2})$/, "+33 $1 $2 $3 $4 $5")
  } else if (cleaned.startsWith("00")) {
    return "+" + cleaned.replace(/^00(\d+)(\d)(\d{2})(\d{2})(\d{2})(\d{2})$/, "$1 $2 $3 $4 $5 $6")
  } else if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4 $5")
  }
  return phoneNumber
}

/**
 * Formate le numéro de téléphone en ajoutant un espace après chaque groupe de chiffres
 * @param phoneNumber
 * @returns string
 */
export function formatPhoneNumberOnInput(phoneNumber) {
  let cleaned = phoneNumber.replace(/[^\d+]/g, "")
  if (cleaned.startsWith("+33")) {
    cleaned = cleaned.replace(
      /(\+33)(\d)(\d{0,2})(\d{0,2})(\d{0,2})(\d{0,2})(\d{0,2})/,
      (match, p1, p2, p3, p4, p5, p6, p7) => `${p1} ${p2} ${p3} ${p4} ${p5} ${p6} ${p7}`.trim()
    )
  } else {
    cleaned = cleaned.replace(/(\d{2})(\d{0,2})(\d{0,2})(\d{0,2})(\d{0,2})/, (match, p1, p2, p3, p4, p5) =>
      `${p1} ${p2} ${p3} ${p4} ${p5}`.trim()
    )
  }
  return cleaned
}

/**
 * Vérifie si un numéro de téléphone est français, c'est-à-dire +33 ou 0x
 * @param phoneNumber
 * @returns boolean
 */
export function isFrenchPhoneNumber(phoneNumber) {
  const phoneRegex = /^(?:\+33|0)[1-9](?:\s?\d{2}){4}$/
  const clearPhoneNumber = phoneNumber.replace(/\s+/g, "")
  return phoneRegex.test(clearPhoneNumber)
}

export function getCountryCodeByTenant(tenant) {
  const tenantCountryMap = {
    [TENANTS.SAMSUNG_ES]: "ES",
    [TENANTS.SAMSUNG_ES_APZ]: "ES",
    [TENANTS.SAMSUNG_PT]: "PT",
    [TENANTS.RETAIL_FNAC_PT]: "PT",
    [TENANTS.SAMSUNG_BE]: "BE",
    [TENANTS.SAMSUNG_NL]: "NL",
    [TENANTS.MEDIAMARKT_NL]: "NL",
    [TENANTS.MEDIAMARKT_BE]: "BE"
  }
  return tenantCountryMap[tenant] || "FR"
}
